module.exports = __webpack_public_path__ + "img/neotag-banner3.8ccf097d.png";